import { memo, useState } from 'react';

import InfoCircleIcon from '@assets/images/icons/icon-info-circle-white.svg?react';

import * as S from './security-banner.styles';

type TSecurityBannerProps = {
	show?: boolean;
};

const SecurityBanner = memo(({ show = true }: TSecurityBannerProps) => {
	const [visible, setVisible] = useState(true);

	if (!visible || !show) return null;

	return (
		<S.Banner id="banner-security" data-qa="security-banner" role="alert">
			<S.Message>
				<InfoCircleIcon aria-hidden="true" />
				Atenção! Não enviamos mensagens ou ligamos solicitando dados pessoais ou códigos por canais não oficiais.
			</S.Message>
			<S.CloseButton type="button" onClick={() => setVisible(false)} aria-label="Fechar aviso de segurança">
				X
			</S.CloseButton>
		</S.Banner>
	);
});

SecurityBanner.displayName = 'SecurityBanner';
export { SecurityBanner };
